/**
 * Barra de arriba de la web. Contiene el logo de Mixreal y botones para gestión de usuario y
 * configuración.
 **/

import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/Navbar.css";
import { Power } from "lucide-react";
import { auth, signOut } from "../db/FirebaseConfig.js";
import logo from "../LogoMixoutfit.png";

const Navbar = () => {
  /*********************************** FUNCIONES DE COMPONENTE ***********************************/
  /***********************************************************************************************/
  //Gestiona cierre de sesión
  const handleLogout = async () => {
    await signOut(auth);
  };

  //Navega a la web principal de Mixoutfit cuando se pincha en el logo
  const navigateHome = () => {
    window.location.href = "https://www.mixoutfit.com";
  };

  /***********************************************************************************************/
  /***********************************************************************************************/

  return (
    <header className="App-header">
      <div className="navbar-logo" onClick={navigateHome}>
        {" "}
        <img src={logo} className="logo" alt="MixReal" />
      </div>
      <div className="navbar-opciones_derecha">
        {/* Botón cerrar sesión */}
        <button
          onClick={handleLogout}
          className="navbar-opciones_derecha--boton_usuario"
        >
          <Power />
          <span className="hover-text">Cerrar sesión</span>
        </button>
      </div>
    </header>
  );
};

export default Navbar;
